/**
 * Toolbar active-state predicates for the calendar module toolbar.
 *
 * Fixes #4233: when the Analysis view is open, the Day/Week/Month buttons must
 * NOT show their is-active highlight, so only one toolbar button looks selected
 * at a time. timeFilter is preserved; closing Analysis (or picking a view)
 * restores the single correct view highlight.
 */

export type CalendarTimeFilter = 'today' | 'week' | 'month';

/**
 * Whether a Day/Week/Month view button should render as active.
 * Active only when its view matches the current timeFilter AND the Analysis
 * pane is closed — Analysis owns its own active state, so the two never
 * highlight simultaneously.
 */
export function isViewButtonActive(
  view: CalendarTimeFilter,
  timeFilter: CalendarTimeFilter,
  showAnalysis: boolean,
): boolean {
  return timeFilter === view && !showAnalysis;
}
